import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GuardUserPermissions } from '@components-shared/Guard/GuardUserPermissions';
import 'antd/dist/reset.css';
import ContextGuard from 'contextStore';
import 'core-js';
import { ROLES } from 'global.enums';
import { MobxRootStoreContext, mobxStore } from 'store/mobx';
import ErrorBoundary from './components/shared/ErrorBoundary/ErrorBoundary';
import UserApp from './components/user';
import { I18nextProvider } from './contextStore/i18nextProvider';
import './styles/user/main.scss';

const container = document.querySelector('.root') as Element;
const userRoot = createRoot(container);

userRoot.render(
  <StrictMode>
    <ErrorBoundary>
      <I18nextProvider>
        <MobxRootStoreContext.Provider value={mobxStore}>
          <BrowserRouter>
            <ContextGuard useClientTranslation={true} registration={false}>
              <GuardUserPermissions role={ROLES.USER}>
                <UserApp />
              </GuardUserPermissions>
            </ContextGuard>
          </BrowserRouter>
        </MobxRootStoreContext.Provider>
      </I18nextProvider>
    </ErrorBoundary>
  </StrictMode>,
);
